"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var _util_1 = require("../../_util");
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var BtnList_1 = __importDefault(require("./BtnList"));
var ContentList_1 = __importDefault(require("./ContentList"));
var BottomBanner = function (props) {
    var className = props.className, _a = props.style, style = _a === void 0 ? {} : _a, bigTitle = props.bigTitle, _b = props.contentList, contentList = _b === void 0 ? [] : _b, description = props.description, _c = props.imgUrl, imgUrl = _c === void 0 ? '' : _c, _d = props.btnList, btnList = _d === void 0 ? [] : _d, backgroundVideoUrl = props.backgroundVideoUrl;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var _e = (0, _util_1.fomateFileData)(imgUrl), _f = _e.url, url = _f === void 0 ? '' : _f, _g = _e.alt, alt = _g === void 0 ? '' : _g;
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-bottom-banner"), className) },
        react_1.default.createElement("div", { className: "main" },
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("div", { className: "big-title" }, bigTitle),
                react_1.default.createElement("div", { className: "content-lists" }, contentList.map(function (item, index) { return (react_1.default.createElement(ContentList_1.default, { key: index, title: item.title, desc: item.desc })); })),
                react_1.default.createElement("div", { className: "content-bottom" },
                    react_1.default.createElement("div", { className: "btn-lists" }, btnList.map(function (item, index) { return (react_1.default.createElement(BtnList_1.default, __assign({ key: index }, item))); })),
                    react_1.default.createElement("div", { className: "description" }, description))),
            react_1.default.createElement("div", { className: "core-img" },
                react_1.default.createElement("img", { className: "img", src: url, alt: alt })),
            backgroundVideoUrl ? (react_1.default.createElement("div", { className: "video-bg" },
                react_1.default.createElement("video", { loop: true, muted: true, autoPlay: true, src: backgroundVideoUrl, className: "video-control" }))) : null)));
};
exports.default = BottomBanner;
//# sourceMappingURL=BottomBanner.js.map